__turbopack_context__.v({
  "barrel": "dark-adaptation-module__uMCgEa__barrel",
  "crescent": "dark-adaptation-module__uMCgEa__crescent",
  "flare": "dark-adaptation-module__uMCgEa__flare",
  "lens-crescent": "dark-adaptation-module__uMCgEa__lens-crescent",
  "lens-draw": "dark-adaptation-module__uMCgEa__lens-draw",
  "lens-fade": "dark-adaptation-module__uMCgEa__lens-fade",
  "lens-flare": "dark-adaptation-module__uMCgEa__lens-flare",
  "lens-launch": "dark-adaptation-module__uMCgEa__lens-launch",
  "lens-letter": "dark-adaptation-module__uMCgEa__lens-letter",
  "lens-rays": "dark-adaptation-module__uMCgEa__lens-rays",
  "lens-settle": "dark-adaptation-module__uMCgEa__lens-settle",
  "lens-sweep": "dark-adaptation-module__uMCgEa__lens-sweep",
  "letter": "dark-adaptation-module__uMCgEa__letter",
  "mark": "dark-adaptation-module__uMCgEa__mark",
  "orbit": "dark-adaptation-module__uMCgEa__orbit",
  "rays": "dark-adaptation-module__uMCgEa__rays",
  "ring": "dark-adaptation-module__uMCgEa__ring",
  "stage": "dark-adaptation-module__uMCgEa__stage",
  "star": "dark-adaptation-module__uMCgEa__star",
  "status": "dark-adaptation-module__uMCgEa__status",
  "trails": "dark-adaptation-module__uMCgEa__trails",
});
